import sortBy from 'lodash/sortBy';
import Vue from "vue";
import { http } from '../../http';
import omit from "lodash/omit";

export default {
    state: {
        discountCodes: [],
        pagination: {},
        loaded: false,
        loading: false
    },

    getters: {
        all: (state) => {
            return sortBy(state.discountCodes, 'code');
        },

        getPagination: (state, getters) => {
            return state.pagination;
        },

        isLoaded: (state, getters) => {
            return state.loaded;
        }
    },

    mutations: {
        add: (state, code) => {
            state.discountCodes.push(code);
        },

        update: (state, code) => {
            const codeIndex = _.findIndex(state.discountCodes, { 'id': code.id });

            if (codeIndex != -1) {
                Vue.set(state.discountCodes, codeIndex, code);
            } else {
                state.discountCodes.push(code);
            }
        },

        delete: (state, code) => {
            state.discountCodes = state.discountCodes.filter(c => c.id !== code.id);
        },

        setDiscountCodes(state, data) {
            state.discountCodes = data.data;
            state.pagination = omit(data, ['data']);
        },

        setLoaded(state) {
            Vue.set(state, 'loaded', true);
        }
    },

    actions: {
        loadDiscountCodes(context, query_params) {
            if (context.loaded || context.loading) {
                return;
            }

            http.get('/app/discount-codes', { params: query_params })
                .then(({ data }) => {
                    context.commit('setDiscountCodes', data);
                    context.loading = false;
                    context.commit('setLoaded');
                });
        },

        loadData(context, query_params) {
            context.dispatch('loadDiscountCodes', query_params);
        },

        loadDiscountCodesToApply(context, body_params) {
            if (context.loaded || context.loading) {
                return;
            }

            http.post('/app/discount-codes/to-apply', body_params)
                .then(data => {
                    context.commit('setDiscountCodes', data);
                    context.loading = false;
                    context.commit('setLoaded');
                });
        },

        loadDataToApply(context, body_params) {
            context.dispatch('loadDiscountCodesToApply', body_params);
        },
    }
}